import { weekdays, weekdaysShortName } from './Constants';

const getDowOpen = (dowClose) =>
  weekdays.map((day) => ({
    name: day,
    value: !dowClose.includes(day.toLowerCase())
  }));

const getDowClose = (dowOpen) => {
  return dowOpen.filter((day) => !day.value).map((day) => day.name.toLowerCase());
};

const openDaysCellRenderer = (params) => {
  return openDaysTooltip(params).map((day) => weekdaysShortName[day.toLowerCase()]);
};

const openDaysTooltip = (params) => {
  return weekdays.filter((day) => !params.data.dowClose.includes(day.toLowerCase()));
};

export { getDowOpen, getDowClose, openDaysCellRenderer, openDaysTooltip };
